<template>
  <div class="settings-view p-4">

    <!-- Loading overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status"></div>
      <div class="loading-text">Caricamento in corso...</div>
    </div>

    <!-- Toast -->
    <ToastDialog :title="toastTitle" :message="toastMessage" :error="toastError" />

    <!-- Card titolo -->
    <div class="card mb-3 shadow-sm">
      <div class="card-body d-flex align-items-center justify-content-between">
        <h5 class="mb-0">Impostazioni valori scadenze</h5>
      </div>
    </div>

    <!-- Tabella impostazioni -->
    <div class="card shadow-sm p-3 table-settings">
      <table class="table mb-0">
        <thead class="table-light">
          <tr>
            <th>Giorni totali</th>
            <th>Pre-scadenza 1</th>
            <th>Pre-scadenza 2</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input type="number" class="form-control" v-model.number="settings.default_expiration_days" min="1">
            </td>
            <td>
              <input type="number" class="form-control" v-model.number="settings.third_column_days" min="0">
            </td>
            <td>
              <input type="number" class="form-control" v-model.number="settings.fourth_column_days" min="0">
            </td>
          </tr>
        </tbody>
      </table>

      <div class="mt-3 text-end">
        <button class="btn btn-primary" @click="saveSettings">Salva</button>
      </div>
    </div>

    <div class="card mt-4 mb-3 shadow-sm">
      <div class="card-body d-flex align-items-center justify-content-between">
        <h5 class="mb-0">Pareri in evidenza</h5>
      </div>
    </div>
    <!-- Pareri in evidenza -->
    <div class="card mt-4 shadow-sm p-3">


      <div v-for="(item, index) in highlighted" :key="index" class="d-flex align-items-center mb-2 gap-2">

        <select class="form-select" v-model="highlighted[index]">
          <option disabled value="">Seleziona quesito</option>
          <option v-for="q in availableQuestions(index)" :key="q.id" :value="q.id">
            {{ q.label }}
          </option>
        </select>

        <button class="btn btn-danger btn-sm" @click="removeRow(index)">
          ✕
        </button>
      </div>

      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-primary btn-sm" @click="addRow">
          + Aggiungi
        </button>

        <button class="btn btn-primary" @click="saveHighlighted">
          Salva
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import ToastDialog from '../../components/common/ToastDialog.vue';
import toastable from '../../mixins/toastable';

export default {
  name: "SettingsView",
  components: { ToastDialog },
  mixins: [toastable],

  data() {
    return {
      settings: {
        default_expiration_days: 15,
        third_column_days: 3,
        fourth_column_days: 1,
      },
      isLoading: true,
      toastTitle: '',
      toastMessage: '',
      toastError: false,

      highlighted: [],
      allQuestions: [],
    };
  },

  methods: {

    async initPage() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.loadSettings(),
          this.loadHighlighted(),
          this.loadAllQuestions()
        ]);
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },

    async loadSettings() {
      const res = await this.$root.$api.get('/admin/settings');
      this.settings = res.data.data;
    },

    async loadHighlighted() {
      const res = await this.$root.$api.get('/admin/highlighted-questions');
      this.highlighted = res.data.data.map(q => q.id);
    },

    async loadAllQuestions() {
      const res = await this.$root.$api.get('/admin/highlighted-selectable');
      this.allQuestions = res.data.data;
    },

    async saveHighlighted() {
      this.isLoading = true;
      try {
        await this.$root.$api.post('/admin/highlighted-questions', {
          question_ids: this.highlighted.filter(Boolean)
        });
        this.showSuccessToast('Pareri aggiornati');
      } catch (err) {
        console.error(err);
        this.showErrorToast('Errore salvataggio pareri');
      } finally {
        this.isLoading = false;
      }
    },

    addRow() {
      if (this.highlighted.length >= 3) {
        this.showErrorToast('Massimo 3 pareri');
        return;
      }
      this.highlighted.push(null);
    },

    removeRow(index) {
      this.highlighted.splice(index, 1);
    },

    availableQuestions(index) {
      return this.allQuestions.filter(q =>
        !this.highlighted.includes(q.id) || this.highlighted[index] === q.id
      );
    }
  },

  mounted() {
    this.initPage();
  }
};
</script>

<style scoped>
.settings-view {
  width: 100%;
}

.table-settings input {
  max-width: 120px;
}

.table-settings table {
  width: 100%;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-text {
  margin-top: 1rem;
  font-weight: bold;
  color: #0d6efd;
}

.table-settings td input {
  width: 100%;
  box-sizing: border-box;
}

.table-settings input {
  max-width: 100%;
}
</style>